import React from "react";
import { useTranslation } from "react-i18next";
import PrimaryButton from "./PrimaryButton";

/**
 * An old link whose card did not answer in time: nothing is wrong with the link, so the way forward is to try again.
 * It uses words every language already has; clearer words follow with their translations.
 */
const OpenFailedMessage = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="text-center relative z-10">
      <p className="text-lg text-slate-700 mb-6">{t("app.errors.generic_error")}</p>
      <PrimaryButton onClick={onRetry} text={t("form_container.submit_button")} />
    </div>
  );
};

export default OpenFailedMessage;
